import ensureAuthenticated from "@/contexts/ensureAuthenticated";
import {
  Avatar,
  Button,
  Menu,
  MenuButton,
  MenuButtonProps,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

export type DropdownMenuProps = {
  identifier?: string;
  items: { name: string; route: string }[];
} & MenuButtonProps;

export default function DropdownMenu({
  identifier,
  items,
  ...props
}: DropdownMenuProps) {
  const navigate = useNavigate();

  const { setAuthenticated } = ensureAuthenticated();

  return (
    <Menu>
      <MenuButton
        as={Button}
        bgColor="transparent"
        colorScheme="transparent"
        rightIcon={<Avatar size="sm" left={{ base: 10 }} />}
        {...props}
      >
        {identifier}
      </MenuButton>
      <MenuList>
        {items.map((el) => (
          <MenuItem key={el.route} onClick={() => navigate(`/${el.route}`)}>
            {el.name}
          </MenuItem>
        ))}
        <MenuItem
          onClick={() => {
            Cookies.remove("session");
            Cookies.remove("refreshToken");

            setAuthenticated({ isAuthenticated: false, user: undefined });
            navigate("/login");
            /* axiosInstance
                            .get('auth/signout')
                            .then((_res) => {
                                setIsAuthCheckComplete(false);
                                setAuthenticated(false);
                                navigate('/login');
                            })
                            .catch((err) => {
                                console.error({ error: err });
                            }) */
          }}
        >
          Sair
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
